/* Create action types */
import createActionTypes from '../createActionTypes';

export const CHANGE_LANGUAGE = createActionTypes('CHANGE_LANGUAGE');
